import { useEffect, useMemo } from "react";

export type FormHandlers = {
  handleSubmit: () => void;
  isSubmitting: boolean;
};

type UseExposeFormHandlersArgs = {
  onFormReady?: (handlers: FormHandlers) => void;
  createSubmit: () => void;
  isSubmitting: boolean;
};

export function useExposeFormHandlers({
  onFormReady,
  createSubmit,
  isSubmitting,
}: UseExposeFormHandlersArgs) {
  const handlers = useMemo<FormHandlers>(
    () => ({
      handleSubmit: createSubmit,
      isSubmitting,
    }),
    [createSubmit, isSubmitting]
  );

  useEffect(() => {
    if (!onFormReady) {
      return;
    }
    onFormReady(handlers);
  }, [handlers, onFormReady]);
}
